export const LOGIN_URL = "/v1/login";
export const SIGNUP_URL = "/v1/signup";
export const CHANGE_PASSWORD_URL = "/v1/change-password";
export const VERIFY_EMAIL_URL = "/v1/verify-email";
export const ADDITIONAL_INFORMATION_URL = "/v1/user/additional-information";
export const RESEND_CODE_URL = "/v1/resend-otp";
export const REQUEST_RESET_PASSWORD_URL = "/v1/request/reset-password";
export const RESET_PASSWORD_URL = "/v1/reset-password";

export const GENERATE_API_KEY_URL = "/v1/generate/api-key";
export const API_KEY_URL = "/v1/api-key";
export const GET_API_KEYS_URL = "/v1/api-keys";
export const UPDATE_API_META_URL = "/v1/update-api-meta";
export const DELETE_API_KEY_URL = "/v1/delete/apikey";
export const ADD_PERMISSION_URL = "/v1/add-api-permission";

export const ORGANIZATION_DETAILS_URL = "/v1/organization";

export const ORGANIZATIONS_URL = "/v1/organizations";
export const GET_ROLES_URL = "/v1/roles";
export const GET_ROLE_PERMISSIONS_URL = "/v1/role-permission";

export const GET_MEMBERS_URL = "/v1/members";
export const MEMBER_URL = "/v1/member";
export const ADD_BULK_MEMBER_URL = "/v1/invite/send";
export const ADD_MEMBER_URL = "/v1/members/add";
export const UPDATE_MEMBER_ROLE_URL = "/v1/update-role";
export const RESEND_INVITATION_URL = "/v1/resend/invite";
export const SELECT_DEFAULT_ORG_URL = "/v1/default-org";

export const GET_USAGE_DASHBOARD_URL = "/v1/get-usage";
export const GET_SUMMARY_URL = "/v1/summary";
export const GET_LIFETIME_USAGE_URL = "/v1/get-lifetime-usage";
export const GET_ORGANIZATION_SUMMARY_URL = "/v1/organization/summary";

export const PROJECT_URL = "/v1/project";

export const PROJECTS_URL = "/v1/projects";

export const SEND_INVITATION_URL = "/v1/invite/send";
export const ACCEPT_INVITATION_URL = "/v1/invite/accept";
export const FETCH_INVITATION_META_URL = "/v1/invite/meta";

export const REFRESH_TOKEN_URL = "/v1/token";

export const BILLING_PROCESS_PAYMENT_URL = "/v1/process/payment";
export const BILLING_INVOICE_LIST_URL = "/v1/list/invoice";
export const BILLING_INVOICE_URL = "/v1/invoice";
export const BILLING_UPDATE_PAYMENT_STATUS_URL = "/v1/payment/status-update";
